module.exports = __webpack_public_path__ + "static/media/sort-alpha-up.8abb100f.svg";